import { AddCircleIcon } from '@forwardflow/assets/svg/AddCircleIcon'
import { AnnouncementIcon } from '@forwardflow/assets/svg/AnnouncementIcon'
import { AppointmentIcon } from '@forwardflow/assets/svg/AppointmentIcon'
import { ArrowDown } from '@forwardflow/assets/svg/ArrowDown'
import { ArrowRight } from '@forwardflow/assets/svg/ArrowRight'
import { BackArrowCircleIcon } from '@forwardflow/assets/svg/BackArrowCircle'
import { CalendarIcon } from '@forwardflow/assets/svg/CalendarIcon'
import { CallIcon } from '@forwardflow/assets/svg/CallIcon'
import { CheckIcon } from '@forwardflow/assets/svg/CheckIcon'
import { ContactIcon } from '@forwardflow/assets/svg/ContactIcon'
import { ForwardIcon } from '@forwardflow/assets/svg/ForwardIcon'
import { GoogleLogo } from '@forwardflow/assets/svg/GoogleLogo'
import { GreenCircleTickIcon } from '@forwardflow/assets/svg/GreenCircleTick'
import { HamburgerIcon } from '@forwardflow/assets/svg/Hamburger'
import { HomeIcon } from '@forwardflow/assets/svg/HomeIcon'
import { InfoIcon } from '@forwardflow/assets/svg/InfoIcon'
import { InviteAgentsIcon } from '@forwardflow/assets/svg/InviteAgentsIcon'
import { MapStageIcon } from '@forwardflow/assets/svg/MapStage'
import { MegaphoneIcon } from '@forwardflow/assets/svg/MegaphoneIcon'
import { MessageIcon } from '@forwardflow/assets/svg/MessageIcon'
import { MessageSmIcon } from '@forwardflow/assets/svg/MessageSmIcon'
import { MicrosoftLogo } from '@forwardflow/assets/svg/MicrosoftLogo'
import { NotificationIcon } from '@forwardflow/assets/svg/NotificationIcon'
import { PurchasePhoneIcon } from '@forwardflow/assets/svg/PurchasePhoneIcon'
import { RecentsIcon } from '@forwardflow/assets/svg/RecentsIcon'
import { SearchIcon } from '@forwardflow/assets/svg/SearchIcon'
import { SmsIcon } from '@forwardflow/assets/svg/SmsIcon'
import { TelephoneIcon } from '@forwardflow/assets/svg/TelephoneIcon'
import { ForwardLargeIcon } from '@forwardflow/assets/svg/ForwardLargeIcon'
import { AppointmentScheduledIcon } from '@forwardflow/assets/svg/AppointmentScheduledIcon'
import { AppointmentMissedIcon } from '@forwardflow/assets/svg/AppointmentMissedIcon'
import { NurtureIcon } from '@forwardflow/assets/svg/NurtureIcon'
import { StopIcon } from '@forwardflow/assets/svg/StopIcon'
import { PersonIcon } from '@forwardflow/assets/svg/PersonIcon'
import { NotQualifiedIcon } from '@forwardflow/assets/svg/NotQualifiedIcon'
import { RepairIcon } from '@forwardflow/assets/svg/RepairIcon'
import { Spinner } from '@forwardflow/assets/svg/Spinner'
import { MailIcon } from '@forwardflow/assets/svg/Mail'
import { FingerprintIcon } from '@forwardflow/assets/svg/Fingerprint'
import { CheckCircleIcon } from '@forwardflow/assets/svg/CheckCircle'
import { CloseCircleIcon } from '@forwardflow/assets/svg/CloseCircle'
import { PauseCircleIcon } from '@forwardflow/assets/svg/PauseCircle'
import { FilterIcon } from '@forwardflow/assets/svg/Filter'
import { GreenArrowIcon } from '@forwardflow/assets/svg/GreenArrow'
import { TourIcon } from '@forwardflow/assets/svg/TourIcon'
import { CloseIcon } from '@forwardflow/assets/svg/CloseIcon'
import { PauseIcon } from '@forwardflow/assets/svg/PauseIcon'
import { EditIcon } from '@forwardflow/assets/svg/EditIcon'
import { ArrowRightSmall } from '@forwardflow/assets/svg/ArrowRightSmall'
import { ChatIcon } from '@forwardflow/assets/svg/Chat'
import { CheckCircleSolidIcon } from '@forwardflow/assets/svg/CheckCircleSolid'
import { CampaignGoalsIcon } from '@forwardflow/assets/svg/CampaignGoals'
import { SupportIcon } from '@forwardflow/assets/svg/Support'
import { QuestionsIcon } from '@forwardflow/assets/svg/Questions'
import { SettingsIcon } from '@forwardflow/assets/svg/Settings'
import { CartIcon } from '@forwardflow/assets/svg/CartIcon'
import { LocationIcon } from '@forwardflow/assets/svg/Location'
import { FiltersIcon } from '@forwardflow/assets/svg/Filters'
import { ForwardFlowIcon } from '@forwardflow/assets/svg/ForwardFlowIcon'
import { PersonaIcon } from '@forwardflow/assets/svg/Persona'
import { DeleteIcon } from '@forwardflow/assets/svg/Delete'
import { PlayIcon } from '@forwardflow/assets/svg/PlayIcon'
import { PlusIcon } from '@forwardflow/assets/svg/Plus'
import { AgentIcon } from '@forwardflow/assets/svg/Agent'
import { DragIcon } from '@forwardflow/assets/svg/DragIcon'
import { UserIcon } from '@forwardflow/assets/svg/UserIcon'
import { ReplaceIcon } from '@forwardflow/assets/svg/ReplaceIcon'
import { ConversationIcon } from '@forwardflow/assets/svg/Conversation'
import { GearIcon } from '@forwardflow/assets/svg/Gear'
import { DownloadIcon } from '@forwardflow/assets/svg/Download'
import { LikeIcon } from '@forwardflow/assets/svg/LikeIcon'
import { CommentIcon } from '@forwardflow/assets/svg/CommentIcon'
import { MissedCallIcon } from '@forwardflow/assets/svg/MissedCallIcon'
import { CallRingIcon } from '@forwardflow/assets/svg/CallRingIcon'
import { AppointmentMissedIconSm } from '@forwardflow/assets/svg/AppointmentMissedIconSm'
import { AppointmentRescheduledIcon } from '@forwardflow/assets/svg/AppointmentRescheduledIcon'
import { SendIcon } from '@forwardflow/assets/svg/SendIcon'
import { OptionsIcon } from '@forwardflow/assets/svg/OptionsIcon'
import { AppointmentTimeframeIcon } from '@forwardflow/assets/svg/AppointmentIconTimeframe'
import { TranscriptIcon } from '@forwardflow/assets/svg/TranscriptIcon'
import { EmailIcon } from '@forwardflow/assets/svg/EmailIcon'
import { HomeSmIcon } from '@forwardflow/assets/svg/HomeSmIcon'
import { ArrowUp } from '@forwardflow/assets/svg/ArrowUp'
import { VoiceMailIcon } from '@forwardflow/assets/svg/VoiceMailIcon'
import { UploadLogoIcon } from '@forwardflow/assets/svg/UploadLogoIcon'
import { LoaderIcon } from '@forwardflow/assets/svg/LoaderIcon'
import { ClockIcon } from '@forwardflow/assets/svg/ClockIcon'
import { OnboardingIcon } from '@forwardflow/assets/svg/OnboardingIcon'

type Props = {
   name: string
   className?: string
   width?: number
   height?: number
}
export default function Icon({ name, className, width, height }: Props) {
   switch (name) {
      case 'upload-logo':
         return <UploadLogoIcon className={className} />
      case 'add-circle':
         return <AddCircleIcon className={className} />
      case 'Agent':
         return <AgentIcon className={className} />
      case 'Announcement':
         return <AnnouncementIcon className={className} />
      case 'Appointment':
         return <AppointmentIcon className={className} />
      case 'AppointmentTimeframeIcon':
         return <AppointmentTimeframeIcon className={className} />
      case 'AppointmentMissed':
         return <AppointmentMissedIcon className={className} />
      case 'AppointmentScheduled':
         return <AppointmentScheduledIcon className={className} />
      case 'arrow-up':
         return <ArrowUp className={className} width={width} height={height} />
      case 'arrow-down':
         return (
            <ArrowDown className={className} width={width} height={height} />
         )
      case 'arrow-right':
         return (
            <ArrowRight className={className} width={width} height={height} />
         )
      case 'ArrowRightSmall':
         return <ArrowRightSmall className={className} />
      case 'back-arrow-circle':
         return <BackArrowCircleIcon className={className} />
      case 'Calendar':
         return <CalendarIcon className={className} />
      case 'Call':
         return <CallIcon className={className} />
      case 'CampaignGoals':
         return <CampaignGoalsIcon className={className} />
      case 'Cart':
         return <CartIcon className={className} />
      case 'Chat':
         return <ChatIcon className={className} />
      case 'Clock':
         return (
            <ClockIcon className={className} width={width} height={height} />
         )
      case 'Check':
         return (
            <CheckIcon className={className} width={width} height={height} />
         )
      case 'CheckCircle':
         return <CheckCircleIcon className={className} />
      case 'CheckCircleSolid':
         return <CheckCircleSolidIcon className={className} />
      case 'Close':
         return <CloseIcon className={className} />
      case 'CloseCircle':
         return <CloseCircleIcon className={className} />
      case 'Contact':
         return <ContactIcon className={className} />
      case 'Conversation':
         return <ConversationIcon className={className} />
      case 'Delete':
         return <DeleteIcon className={className} />
      case 'Download':
         return <DownloadIcon className={className} />
      case 'Drag':
         return <DragIcon className={className} />
      case 'Edit':
         return <EditIcon className={className} />
      case 'Email':
         return <EmailIcon className={className} />
      case 'Filter':
         return <FilterIcon className={className} />
      case 'Filters':
         return <FiltersIcon className={className} />
      case 'Fingerprint':
         return <FingerprintIcon className={className} />
      case 'Forward':
         return <ForwardIcon className={className} />
      case 'ForwardFlow':
         return <ForwardFlowIcon className={className} />
      case 'ForwardLarge':
         return <ForwardLargeIcon className={className} />
      case 'Gear':
         return <GearIcon className={className} />
      case 'google-icon':
         return <GoogleLogo className={className} />
      case 'green-circle-tick':
         return <GreenCircleTickIcon className={className} />
      case 'GreenArrow':
         return <GreenArrowIcon className={className} />
      case 'Hamburger':
         return <HamburgerIcon className={className} />
      case 'home':
         return <HomeIcon className={className} />
      case 'Home':
         return <HomeSmIcon className={className} />
      case 'Info':
         return <InfoIcon className={className} width={width} height={height} />
      case 'invite-agents':
         return <InviteAgentsIcon className={className} />
      case 'Location':
         return <LocationIcon className={className} />
      case 'Mail':
         return <MailIcon className={className} />
      case 'map-stage':
         return <MapStageIcon className={className} />
      case 'Megaphone':
         return <MegaphoneIcon className={className} />
      case 'Message':
         return <MessageIcon className={className} />
      case 'MessageSmIcon':
         return <MessageSmIcon className={className} />
      case 'microsoft-icon':
         return <MicrosoftLogo className={className} />
      case 'notification':
         return <NotificationIcon className={className} />
      case 'NotQualified':
         return <NotQualifiedIcon className={className} />
      case 'Nurture':
         return <NurtureIcon className={className} />
      case 'Loader':
         return <LoaderIcon className={className} />
      case 'Pause':
         return <PauseIcon className={className} />
      case 'PauseCircle':
         return <PauseCircleIcon className={className} />
      case 'Play':
         return <PlayIcon className={className} />
      case 'Plus':
         return <PlusIcon className={className} />
      case 'Person':
         return <PersonIcon className={className} />
      case 'Persona':
         return <PersonaIcon className={className} />
      case 'purchase-phone':
         return <PurchasePhoneIcon className={className} />
      case 'Questions':
         return <QuestionsIcon className={className} />
      case 'Recents':
         return <RecentsIcon className={className} />
      case 'Repair':
         return <RepairIcon className={className} />
      case 'Replace':
         return <ReplaceIcon className={className} />
      case 'search':
         return <SearchIcon className={className} />
      case 'Settings':
         return <SettingsIcon className={className} />
      case 'Sms':
         return <SmsIcon className={className} />
      case 'Spinner':
         return <Spinner className={className} />
      case 'Stop':
         return <StopIcon className={className} width={width} height={height} />
      case 'Support':
         return <SupportIcon className={className} />
      case 'Transcript':
         return <TranscriptIcon className={className} />
      case 'Telephone':
         return <TelephoneIcon className={className} />
      case 'TourIcon':
         return <TourIcon className={className} />
      case 'User':
         return <UserIcon className={className} />
      case 'VoiceMail':
         return <VoiceMailIcon className={className} />
      case 'Like':
         return <LikeIcon className={className} />
      case 'Comment':
         return <CommentIcon className={className} />
      case 'MissedCall':
         return <MissedCallIcon className={className} />
      case 'CallRing':
         return <CallRingIcon className={className} />
      case 'AppointmentMissedSmall':
         return <AppointmentMissedIconSm className={className} />
      case 'AppointmentScheduledSmall':
         return <AppointmentRescheduledIcon className={className} />
      case 'Send':
         return <SendIcon className={className} />
      case 'Options':
         return <OptionsIcon className={className} />
      case 'Onboarding':
         return <OnboardingIcon className={className} />
   }
}
